/*
 * Copyright (c) 2021 CalAmp Corp.  All Rights Reserved
 */
import {useSelector} from 'react-redux';
import {CTCEntity} from '@ion/core/src/types/entities';

/**
 * Provides a utility hook for getting the update operation results for any entity via
 * its respective reducer ...
 *
 * ```typescript
 *
 *   import {useUpdateResults} from '@ion/dls/src/hooks/';
 *   const updateResult = useUpdateResults('reducer');
 *
 * ```
 */
export const useUpdateResults = (reducer: string): CTCEntity | CTCEntity[] => {
  return useSelector(({[reducer]: {update}}) => update?.result);
};

export default useUpdateResults;
